import PropTypes from "prop-types";

function StepNumber({ number }) {
  return (
    <svg
      className="MuiSvgIcon-root MuiStepIcon-root MuiStepIcon-active"
      focusable="false"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="12" />
      <text className="MuiStepIcon-text" x="12" y="16" textAnchor="middle">
        {number}
      </text>
    </svg>
  );
}

StepNumber.propTypes = {
  number: PropTypes.number.isRequired,
};

export default StepNumber;
